<template>
  <div class="text-wrapper">
    <!-- 搜索项 -->
    <div class="search-wrapper flex">
      <div class="input-wrapper flex">
        <p>证书名称：</p>
        <el-input v-model="tableInfo.query.name" placeholder="请输入证书名称"></el-input>
        <p style="margin-left:20px">证书状态：</p>
        <el-select v-model="tableInfo.query.status">
          <el-option
            v-for="item in stateList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="btn-wrapper">
        <el-button type="primary" @click="getList">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <div class="table">
      <teacher-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="tableInfo.query"
        :pager="true"
        :tab-index="true"
        :api="getCertificate"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <template v-slot:col-templateUrl="scope">
          <img
            :src="scope.row.templateUrl"
            v-if="scope.row.templateUrl"
            style="height:36px;"
            @click="handleShow(scope.row.templateUrl)">
          <span v-else> - </span>
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-status="scope">
          <p>{{ scope.row.status === 1 ? '已启用' : '已停用' }}</p>
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-templateType="scope">
          <p>{{ scope.row.templateType }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-status="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.status === 1 ? '停用' : '启用' }}
          </el-button>
        </template>
      </teacher-table>
    </div>
    <preview :photo-shows="showPreview" :url="previewUrl" @showSrue="showPreview = false"></preview>
  </div>
</template>
<script>
import TeacherTable from '@/components/PublicTable';
import Preview from './components/preview';
import { getCertificate, updateCertificateInfo } from '@/api/api'
export default {
  components: {
    TeacherTable,
    Preview
  },
  data() {
    return {
      getCertificate,
      showPreview: false,
      previewUrl: '',
      stateList: [
        { label: '全部', value: 0 },
        { label: '已启用', value: 1 },
        { label: '已停用', value: 2 },
      ],
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        query: {
          name: '',
          status: ''
        },
        fieldList: [
          { label: '证书名称', value: 'name'},
          { label: '证书模板', value: 'templateUrl', type: 'slot' },
          { label: '模板类型', value: 'templateType', type: 'slot' },
          { label: '证书状态', value: 'status', type: 'slot' },
          { label: '操作人', value: 'insertName' },
          { label: '更新时间', value: 'lastUpdateDate' }
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '启用', type: 'text', event: 'status', show: true, slot: true }
          ]
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    handleShow(url) {
      this.showPreview = true;
      this.previewUrl = url;
    },
    // 通过随机数请求列表
    getList() {
      this.tableInfo.refresh = Math.random();
    },
    // 重置
    reset() {
      this.tableInfo.query.name = '';
      this.tableInfo.query.status = '';
      this.getList();
    },
    // table操作
    handleClick(event, row) {
      updateCertificateInfo({
        id: row.id,
        status: row.status === 1 ? 2 : 1
      }).then(res => {
        let { code, message } = res;
        if (code === 0) {
          this.$message.success(row.status === 1 ? '停用成功' : '启用成功');
          this.getList();
        } else {
          this.$message.error(message);
        }
      })
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
  },
}
</script>
<style lang="scss" scoped>
.text-wrapper {
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .search-wrapper {
    width: 100%;
    .input-wrapper {
      .el-input {
        width: 200px;
        margin-left: 10px;
      }
    }
    .btn-wrapper {
      margin-left: 30px;
    }
  }

  .table {
    margin-top: 20px;
    .el-button {
      margin-bottom: 10px;
    }
  }
}
</style>